import { type ValueOf } from '@dni-types/utilities/value-of'

export const API_ERROR_TYPES = {
  AUTHENTICATION_ERROR: 'AUTHENTICATION_ERROR',
} as const

export type ApiErrorTypeValue = ValueOf<typeof API_ERROR_TYPES>
